import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApplicationService } from '../../shared/services/application/application.service';
import { CopyService } from '../../shared/services/copies/copy.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { ISolicitation } from '../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { IEventResponseFindClient, EStatusFindClient } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { SolicitationStartComponent } from '../solicitation-start/solicitation-start.component';
import { TokenService } from '../../shared/services/security/token.service';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { EVENT } from '../../shared/constants/dali.constants';
import { CatalogService } from '../../shared/services/catalogs/catalog.service';

@Component({
  selector: 'app-bank-start',
  templateUrl: './bank-start.component.html',
  styleUrls: ['./bank-start.component.scss']
})
export class BankStartComponent extends SolicitationStartComponent implements OnInit {
  CONTENT_BOUNDS: any[] | any;
  stepsList: string[] = [];
  solicitationData: ISolicitation = {};
  form: FormGroup = this._fbB.group({
    basic_data: this._fbB.group({}),
    contacts_data: this._fbB.group({})
  });

  actionToken = 'radication';

  constructor(
    private readonly _solicitationB: RequestSolicitationsService,
    private readonly _cpsB: CopyService,
    private readonly _fbB: FormBuilder,
    private readonly _appB: ApplicationService,
    private readonly _tokenB: TokenService,
    private readonly _link: LinkupService,
    private readonly _catalogB: CatalogService
  ) {
    super(_solicitationB, _cpsB, _fbB, _tokenB, _appB, _link, _catalogB);
    super.idComponent = "bank-start";
  }

  ngOnInit(): void {
    this.loadStaticValues().finally(() => {
      super.onLoad();
    });
    this.loadData();
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    this._appB.channelId = "160";
    this._appB.currentApplication = "bank";
    this._catalogB.clearCache();
    this.CONTENT_BOUNDS = await this._cpsB.getCopy("bank-start");
    this.stepsList = await this._cpsB.getCopy("stepList", []);
  }

  loadData() {
    this.solicitationData = this._solicitationB.solicitation;
  }

  onCloseEvent($event: any) {
    console.log("closeEvent");
  }

  get customerExists(): FormControl {
    return this.form.get('customer_exists') as FormControl;
  }

  /**
   * Permite obtener la referencia al control customer_error
   */
  get customerError(): FormControl {
    return this.form.get('customer_error') as FormControl;
  }

  get basicDataForm(): FormGroup {
    return this.form.get('basic_data') as FormGroup;
  }

  get customerLoaded(): FormControl {
    return this.form.get('customer_loaded') as FormControl;
  }

  async findClient($event: IEventResponseFindClient) {
    const BACKUP_CONTACTS = this.solicitationData.contactsData;
    super.findClient($event);
    this.solicitationData.basicData = this.basicDataForm.value;
    if ($event.status === EStatusFindClient.NO_VALIDATE) {
      this.solicitationData.contactsData = BACKUP_CONTACTS;
    }

  }

  get termsForm(): FormGroup {
    return this.form as FormGroup;
  }

  async navigateTo(start: any) {
    if (start === "next") {
      this.solicitationData.basicData = this.basicDataForm.value;
      this.solicitationData.contactsData = this.contactsDataForm.value;
      this._solicitationB.solicitation = this.solicitationData;

      console.log('solicitation', this._solicitationB.solicitation);

      let eventSetting = this.getSetting("analytics", "trackEvent.e5", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionName.path}",
          "value": EVENT.pv2E5setData.pv2E5transactionName.value
        },
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        },
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionProductDetails.path}",
          "value": getValueProperty(this._solicitationB.solicitation, "analyticsData.document_type", "")
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);

      let isValidCaptcha = true;
      let validateRecaptchaOnNextStep = this.getSetting("services", "validateRecaptchaOnNextStep", false);

      if (validateRecaptchaOnNextStep) {
        isValidCaptcha = await this._appB.validateRecaptcha(this.actionToken);
      }

      if (isValidCaptcha) {
        await this._solicitationB.navigation.nextStep();
      } else if (!isValidCaptcha) {
        console.error('Captcha is invalid');
        this._solicitationB.reset();
        await this._appB.recaptchaToken({ action: this.actionToken });
      }

    } else {

      let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionName.path}",
          "value": EVENT.pv2E5setData.pv2E5transactionName.value
        },
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        },
        {
          "name": "{EVENT.pv2E5setData.pv2E5transactionProductDetails.path}",
          "value": getValueProperty(this._solicitationB.solicitation, "analyticsData.document_type", "")
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);

      await this._solicitationB.navigation.previousStep();
    }
  }

  /**
   * Permite obtener la instancia del formulario para la información de contactos del cliente
   */
  get contactsDataForm(): FormGroup {
    return this.form.get('contacts_data') as FormGroup;
  }

}
